import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import Cookies from "js-cookie";
import auth_service from "../../../src/services/auth_service";
import api_service from "../../../src/services/api_services";
import { motion } from "framer-motion";
import { FaLock, FaRedo, FaKey } from "react-icons/fa";
import toast from "react-hot-toast";
import { useWishlist } from "../../context/WishlistContext";

const VerifyOtp = () => {
  const [otp, setOtp] = useState(new Array(6).fill(""));
  const [errotp, setErrotp] = useState("");
  const [error, setError] = useState("");
  const [resendMessage, setResendMessage] = useState("");
  const { syncWishlistOnLogin } = useWishlist();

  const navigate = useNavigate();
  const location = useLocation();
  const phoneNumber = location.state?.phoneNumber;
  const referralCode = location.state?.referralCode;
  const referrerCustomerId = location.state?.referrerCustomerId;
  const from = location.state?.from || "/";

  const handleOtpChange = (value, index) => {
    if (!/^\d?$/.test(value)) return;
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value && index < 5) {
      document.getElementById(`otp-input-${index + 1}`).focus();
    }
    setErrotp("");
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      const newOtp = [...otp];
      if (otp[index]) {
        newOtp[index] = "";
        setOtp(newOtp);
      } else if (index > 0) {
        document.getElementById(`otp-input-${index - 1}`).focus();
      }
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const data = e.clipboardData.getData("Text").replace(/\D/g, "").slice(0, 6);
    const newOtp = [...otp];
    data.split("").forEach((digit, i) => {
      if (i < 6) newOtp[i] = digit;
    });
    setOtp(newOtp);

    const lastFilledIndex = data.length - 1;
    if (lastFilledIndex < 6) {
      document.getElementById(`otp-input-${lastFilledIndex}`).focus();
    }
  };

  const handleResendOtp = async () => {
    try {
      setResendMessage("Resending OTP...");
      await auth_service.login(phoneNumber);
      setResendMessage("OTP resent successfully!");
    } catch {
      setResendMessage("Failed to resend OTP. Please try again.");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const otpString = otp.join("");
    if (otpString.length !== 6) {
      setErrotp("Enter a valid 6-digit OTP");
      return;
    }

    try {
      const data = await auth_service.verifyOtp(phoneNumber, otpString);

      if (data.message === "OTP verified successfully") {
        Cookies.set("accessToken", data.accessToken, { expires: 7 });
        Cookies.set("refreshToken", data.refreshToken, { expires: 14 });
        
        const customerId = auth_service.getAccessTokenData()?.id;

        const user = {
        wallet: 50,
       referred_id: referrerCustomerId,
        id: customerId,
      };
       const user1 = {
        wallet: 50,
        id: customerId,
      };

        // Process referral if parameters exist
        if (referralCode && referrerCustomerId && customerId) {
          console.log("Processing referral:", { customerId, referrerCustomerId, referralCode });
          try {
            // Process referral using editProfile method
            const referralResponse = await api_service.updateReferalForNewUSer(user);
            const referralResponse1 = await api_service.updateReferalForExistingUSer(user1);
            console.log("Referral response:", referralResponse);
            
            toast.success("🎉 Welcome! You and your friend both earned 50 points!", {
              duration: 4000,
              position: "top-center",
              style: {
                background: "#10B981",
                color: "#fff",
              },
            });
          } catch (error) {
            console.error("Error processing referral:", error);
            
            toast.error("Referral processing failed, but your login was successful!", {
              duration: 3000,
              position: "top-center",
            });
          }
        }

              // Fetch the cart from localStorage
      try {
        const cart = JSON.parse(localStorage.getItem("cart")) || [];
        const updatedCart = cart.map((item) => ({
            ...item,
            customer_id: customerId,
        }));
    
        const response = await api_service.addMultipleItemsToCart(updatedCart);
        if (response.success === true) {
            localStorage.removeItem("cart");
        }
    } catch (error) {
        console.error("Error adding items to cart:", error);
    }
    
    try {
        // Sync wishlist on login using the context
        await syncWishlistOnLogin();
    } catch (error) {
        console.error("Error syncing wishlist on login:", error);
    }
    
    // Navigate to the intended page after successful login
    navigate(from, { replace: true });
      } else if (data.message === "Incorrect OTP") {
        setError("Incorrect OTP");
      } else {
        setError("Failed to verify OTP. Please try again.");
      }
    } catch (err) {
      setError("Failed to verify OTP. Please try again.");
    }
  };

  // Animation variants
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: { 
      opacity: 1,
      transition: { 
        duration: 0.5,
        when: "beforeChildren",
        staggerChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: { y: 0, opacity: 1, transition: { duration: 0.5 } }
  };

  // Timer for OTP expiration
  const [timer, setTimer] = useState(120); // 2 minutes in seconds
  const [isTimerActive, setIsTimerActive] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    let interval = null;
    if (isTimerActive && timer > 0) {
      interval = setInterval(() => {
        setTimer(timer => timer - 1);
      }, 1000);
    } else if (timer === 0) {
      setIsTimerActive(false);
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [isTimerActive, timer]);

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs < 10 ? '0' : ''}${secs}`;
  };

  const resetTimer = () => {
    setTimer(120);
    setIsTimerActive(true);
  };

  const handleResendWithTimer = async () => {
    await handleResendOtp();
    resetTimer();
    toast.success("OTP resent successfully", {
      duration: 3000,
      position: "top-center",
    });
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    await handleSubmit(e);
    setIsSubmitting(false);
  };

  return (
    <div
      className="w-full min-h-screen flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8"
      style={{
        background: `linear-gradient(to right, rgb(31, 80, 154), rgb(0, 0, 102))`,
      }}
    >
      <motion.div 
        initial="hidden"
        animate="visible"
        variants={containerVariants}
        className="bg-white shadow-2xl rounded-2xl w-full max-w-md overflow-hidden"
      >
        {/* Header */}
        <div 
          className="p-8 text-white text-center"
          style={{
            background: `linear-gradient(to right, rgb(31, 80, 154), rgb(0, 0, 102))`
          }}
        >
          <div className="w-12 h-1 bg-gradient-to-r from-yellow-400 to-amber-500 mx-auto mb-6 rounded-full"></div>
          
          <motion.h1 
            variants={itemVariants}
            className="text-3xl font-bold mb-2"
          >
            Verify OTP
          </motion.h1>
          <motion.p 
            variants={itemVariants}
            className="text-blue-100 opacity-90"
          >
            Enter the code sent to your whatsapp number
          </motion.p>
        </div>

        <div className="p-8">
          <form className="space-y-6" onSubmit={handleFormSubmit}>
            {/* Error message */}
            {error && (
              <motion.div 
                initial={{ opacity: 0, y: -10 }}
                animate={{ opacity: 1, y: 0 }}
                className="bg-red-50 border border-red-200 p-4 rounded-lg"
              >
                <p className="text-red-800 text-sm">{error}</p>
              </motion.div>
            )}

            <motion.div variants={itemVariants} className="space-y-4">
              <div className="text-center mb-4">
                <div className="flex items-center justify-center mb-2">
                  <FaKey className="text-amber-600 h-6 w-6 mr-2" />
                  <span className="text-gray-700 font-medium">One Time Password</span>
                </div>
              </div>
              
              <div className="flex justify-center gap-2" onPaste={handlePaste}>
                {otp.map((digit, index) => (
                  <motion.input
                    key={index}
                    initial={{ opacity: 0, y: 20, scale: 0.8 }}
                    animate={{ 
                      opacity: 1, 
                      y: 0, 
                      scale: 1,
                      transition: { 
                        delay: index * 0.05,
                        duration: 0.3,
                        type: "spring",
                        stiffness: 200
                      } 
                    }}
                    id={`otp-input-${index}`}
                    type="text"
                    inputMode="numeric"
                    autoComplete="one-time-code"
                    maxLength="1"
                    value={digit}
                    onChange={(e) => handleOtpChange(e.target.value, index)}
                    onKeyDown={(e) => handleKeyDown(e, index)}
                    className="w-12 h-14 text-center text-xl font-bold border-2 border-gray-300 rounded-lg outline-none focus:border-amber-500 focus:ring-2 focus:ring-amber-200 transition-all duration-200"
                  />
                ))}
              </div>
              {errotp && (
                <motion.p 
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  className="text-red-600 text-sm text-center mt-2"
                >
                  {errotp}
                </motion.p>
              )}

              {/* Timer display */}
              <div className="text-center text-sm text-gray-500 mt-4">
                {isTimerActive ? (
                  <p>OTP expires in <span className="font-mono font-bold text-amber-600">{formatTime(timer)}</span></p>
                ) : (
                  <p className="text-red-600">OTP has expired. Please request a new one.</p>
                )}
              </div>
            </motion.div>

            {/* Verify Button */}
            <motion.button
              variants={itemVariants}
              type="submit"
              disabled={isSubmitting || !isTimerActive}
              className="w-full py-3 px-4 rounded-lg text-white font-medium transition-all duration-200 hover:opacity-90 focus:outline-none focus:ring-2 focus:ring-amber-500 focus:ring-offset-2 disabled:opacity-50"
              style={{
                background: `linear-gradient(to right, rgb(31, 80, 154), rgb(0, 0, 102))`,
              }}
            >
              {isSubmitting ? (
                <div className="flex items-center justify-center">
                  <div className="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin mr-2"></div>
                  Verifying...
                </div>
              ) : (
                "Verify OTP"
              )}
            </motion.button>

            {/* Resend OTP */}
            <motion.div variants={itemVariants} className="flex justify-center mt-4">
              <button
                type="button"
                onClick={handleResendWithTimer}
                disabled={isTimerActive && timer > 90}
                className="flex items-center text-amber-600 hover:text-amber-500 transition-colors duration-200 disabled:text-gray-400 disabled:cursor-not-allowed"
              >
                <FaRedo className="mr-2" />
                Resend OTP
              </button>
            </motion.div>
            
            {resendMessage && (
              <motion.p 
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                className="text-amber-600 text-sm text-center mt-2"
              >
                {resendMessage}
              </motion.p>
            )}

            {/* Sign Up Link */}
            <motion.p variants={itemVariants} className="text-sm text-center mt-6 text-gray-600">
              Don't have an account?{" "}
              <Link 
                to="/signup" 
                className="font-medium text-amber-600 hover:text-amber-500 transition-colors duration-200"
              >
                Sign up
              </Link>
            </motion.p>
          </form>
        </div>
      </motion.div>
    </div>
  );
};

export default VerifyOtp;